<template>
  <div
    :class="containerFullClassName"
    id="containerFull_body"
    v-if="currThemeObj"
  >
    <div class="fix_header">
      <platfrom_menu
        :currThemeObj="currThemeObj"
        :selectData="platfromMenu_selectData"
        :userInfor="platfromMenu_userInfor"
        :groupList="platfromMenu_groupList"
        :currGroup="platfromMenu_currGroup"
        :currCid="currCid"
        :currSid="currSid"
        :curPageInitNum="containerFull_curPageInitNum"
        :timeZoneFlag="platfromMenu_timeZoneFlag"
        @changeSidToInitPageEvent="changeSidToInitPage"
        @changeSidEvent="platfrom_changeSid"
        @changeGroupEvent="platfromMenu_changeGroup"
        @timeZoneFlagEvent="platfromMenu_timeZoneFlagEvent"
      ></platfrom_menu>
    </div>
    <div class="mix_body">
      <router-view
        :axiosBaseUrl="baseUrl"
        :currGroup="platfromMenu_currGroup"
        :groupChangeInitPage="containThemeRouteName"
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :sportsTypeArr="sportsTypeArr"
        :curPageInitNum="containerFull_curPageInitNum"
        :bigSportsList="bigSportsList"
        :themeHeaderBannerImage="'scheduleDetail_banner'"
        :curTimeZoneItem="platfromMenu_curTimeZoneItem"
      ></router-view>
    </div>

    <div class="mix_footer">
      <component :is="footerCustomDom" :currThemeObj="currThemeObj" />
    </div>
    <publicThemeDialog
      v-if="isShowPublicThemeDialog"
      :currThemeObj="currThemeObj"
      :isDialogFlag="isShowPublicThemeDialog"
      :dialogObj="publicThemeDialogObj"
      :axiosBaseUrl="baseUrl"
      :currGroup="platfromMenu_currGroup"
      :currCid="currCid"
      :currSid="currSid"
      :curTimeZoneItem="platfromMenu_curTimeZoneItem"
      @publicThemeDialogEvent="publicThemeDialogHandler"
      @actStyleItemEvent="actStyleItemEventHandler"
    ></publicThemeDialog>
  </div>
</template>

<script>
// 综合性运动会  公共容器
import CSMeetCommon_data_mixin from '@mixins/compreSportsMeet/CSMeetCommon_data_mixin'
const ASG2026_CODE = 'ASG2026'

export default {
  name: 'compreSportsMeet_common',
  props: {
    bigSportsList: {
      type: [Array, null],
      default: null,
    },
    containerFullClassName: {
      type: String,
      default: '',
    },
    defaultPath: {
      type: Array,
      default: () => {
        return []
      },
    },
    axiosBaseUrl: {
      type: String,
      default: '',
    },
    sportCompetitionType: {
      type: String, //赛事类型
      default: '',
    },
    themeSeasonArr: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  mixins: [CSMeetCommon_data_mixin],
  computed: {
    baseUrl() {
      return this.currSid === ASG2026_CODE ? '/games' : this.axiosBaseUrl
    },
  }
}
</script>

<style lang="scss">
#containerFull_body {
  position: relative;
  width: 100%;
  /* height: auto; */
  font-size: 0.972vw;
  max-height: 100vh;
  overflow: auto;
  & .fix_header {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1500;
    width: 100%;
    height: 8vw;
    background-color: var(--mixtmt_whiteColor);
  }
  & .mix_body {
    min-height: calc(100vh - 8vw - 9.722vw);
    padding: 0 9.722vw;
  }
  & .mix_footer {
    /* position: absolute;
        bottom: 0;
        left: 0;
        z-index: 1000; */
    width: 100%;
  }
}

.mixtmt_pc {
  #containerFull_body {
    /* padding: 8vw 9.722vw 9.722vw; */
    padding: 8vw 0 0 0;
  }
}
.mixtmt_ipad {
  #containerFull_body {
    /* padding: 8vw 3vw 9.722vw; */
    padding: 8vw 0 0 0;
  }
}
@media screen {
  /* #app.mixtmt_pc {
          #containerFull_body {
          }
        } */
}

/* .spinner {
          margin: 4vw auto 0 auto;
          width: 30vw;
          text-align: center;
        }
        
        .spinner > div {
          margin: 0 1vw;
          width: 4vw;
          height: 4vw;
          border-radius: 100%;
          display: inline-block;
          -webkit-animation: bouncedelay 1.4s infinite ease-in-out;
          animation: bouncedelay 1.4s infinite ease-in-out;
          -webkit-animation-fill-mode: both;
          animation-fill-mode: both;
        }
        .spinner > div:nth-child(1) {
          background-color: #1b94d3;
        }
        
        .spinner > div:nth-child(2) {
          background-color: #8bc34a;
        }
        
        .spinner > div:nth-child(3) {
          background-color: #ffb74d;
        }
        
        .spinner .bounce1 {
          -webkit-animation-delay: -0.32s;
          animation-delay: -0.32s;
        }
        
        .spinner .bounce2 {
          -webkit-animation-delay: -0.16s;
          animation-delay: -0.16s;
        }
        
        @-webkit-keyframes bouncedelay {
          0%,
          80%,
          100% {
            -webkit-transform: scale(0);
          }
          40% {
            -webkit-transform: scale(1);
          }
        }
        
        @keyframes bouncedelay {
          0%,
          80%,
          100% {
            transform: scale(0);
            -webkit-transform: scale(0);
          }
          40% {
            transform: scale(1);
            -webkit-transform: scale(1);
          }
        } */
</style>
